import logo from "./starworksLogo.png";
import starhoundImg from "./assets/starhound.png";
import timeworksImg from "./assets/timeworks.png";
import discordLogo from "./assets/socialLogos/discordLogo.png";
import "./App.css";
import Button from "react-bootstrap/Button";
import { Header } from "./components";
import BlogFeatureDisplay from "./components/BlogFeatureDisplay";
import { BlogPost, blankBlogPost, getBlogPosts } from "./util";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Footer from "./components/Footer";
import { LandingPage } from "./components/LandingPage";
import FloatingEmailBubble from "./components/FloatingEmailBubble";

function App() {
  const navigate = useNavigate();
  const emptyBlogs: BlogPost[] = [];
  const [featuredBlogs, setFeaturedBlogs] = useState(emptyBlogs);
  const [newsSection, setNewsSection] = useState(<></>);

  useEffect(() => {
    retrieveData();
  }, []);

  useEffect(() => {
    setNewsSection(
      featuredBlogs.length > 0 ? (
        <div className="color-backdrop" style={{ width: "100%" }}>
          <div
            className="d-flex"
            style={{
              justifyContent: "center",
              alignItems: "center",
              gap: "3rem",
              marginTop: "1rem",
              padding: "0rem 1rem",
            }}
          >
            {featuredBlogs.map((blog, index) => (
              <BlogFeatureDisplay key={index} blogPost={blog} />
            ))}
          </div>
          <div className="m-3"></div>
        </div>
      ) : (
        <></>
      )
    );
  }, [featuredBlogs]);

  async function retrieveData() {
    const blogList = await getBlogPosts();
    const sorted = blogList
      .filter((p) => p.published)
      .sort((a, b) => b.creationDate.getTime() - a.creationDate.getTime());
    setFeaturedBlogs(sorted.slice(0, 3));
  }

  return (
    <>
      <Header />
      <div className="App-backdrop">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {/* Add more routes here for additional pages */}
        </Routes>
        {newsSection}
      </div>
      <Footer />
    </>
  );
}

export default App;
